/**
 * An empty state config containing component properties
 */
var EmptyStateConfig = /** @class */ (function () {
    function EmptyStateConfig() {
    }
    return EmptyStateConfig;
}());
export { EmptyStateConfig };
//# sourceMappingURL=empty-state-config.js.map